import * as React from 'react';
import styled, { useTheme } from 'styled-components';
import { IconButton } from '../Button';
import { SystemIcons } from '../icons';
import { COLORS } from '../styles';
import { ModalHeader, ModalBody, ModalFooter } from './ModalStyles';

/**
 * Modal styles
 */
const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  height: 100%;
`;

const StyledButton = styled(IconButton)`
  display: flex;
`;

export const ModalCloseButton: React.FunctionComponent<{ onClick: () => void }> = ({ onClick }) => {
  const theme = useTheme();
  return (
    <StyledButton variant="secondary" shape="square" action={onClick}>
      <SystemIcons.Close size="24px" color={COLORS.generateToken({componentType: 'icon', defaultVariant:'subtle'}, theme)} />
    </StyledButton>
  );
};

type ModalProps = {
  children: any;
};

const Modal = ({ children }: ModalProps) => <Column>{children}</Column>;

Modal.Header = ({ children }: ModalProps) => <ModalHeader>{children}</ModalHeader>;

Modal.Body = ({ children }: ModalProps) => <ModalBody>{children}</ModalBody>;

Modal.Footer = ({ children }: ModalProps) => <ModalFooter>{children}</ModalFooter>;

export default Modal;
